import FormPageTemplate from './FormPageTemplate'

const RoofingNewProjectPage = () => (
    <FormPageTemplate
        titleKey="admin.monday.roofing_new_project"
        subtitleKey="admin.monday.roofing_form_desc"
        defaultFormType="roofing_new_project"
        returnPath="/roofing"
    />
)

export default RoofingNewProjectPage
